import { IconAlertCircle } from '@tabler/icons-react'
import styled from 'styled-components'

export const Icon = styled(IconAlertCircle)`
	color: ${({ theme }) => theme.color.input.textContrast};
	margin: 8px 0 0 5px;
`
